import React from "react";
import { ORDER_STATUSES } from "./useAdminOrders";

export default function AdminOrdersFilters({ filters, setFilters, filterOptions }) {
  return (
    <div className="bg-white rounded-xl border border-[--border] p-4 mb-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3" data-testid="filters-panel">
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Status</label>
        <select
          value={filters.status}
          onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        >
          <option value="">All Statuses</option>
          {ORDER_STATUSES.map((s) => (
            <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Category</label>
        <select
          value={filters.category}
          onChange={(e) => setFilters((f) => ({ ...f, category: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        >
          <option value="">All Categories</option>
          {filterOptions.categories.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Agent</label>
        <select
          value={filters.salesperson_id}
          onChange={(e) => setFilters((f) => ({ ...f, salesperson_id: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        >
          <option value="">All Agents</option>
          {filterOptions.salespeople.map((s) => (
            <option key={s.id} value={s.id}>{s.name || s.email}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Sort By</label>
        <select
          value={filters.sort_by}
          onChange={(e) => setFilters((f) => ({ ...f, sort_by: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        >
          <option value="created_at">Date</option>
          <option value="amount">Amount</option>
          <option value="discount_percent">Discount %</option>
          <option value="customer_name">Customer Name</option>
        </select>
      </div>
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Order</label>
        <select
          value={filters.sort_order}
          onChange={(e) => setFilters((f) => ({ ...f, sort_order: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        >
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </select>
      </div>
      <div>
        <label className="text-[10px] font-medium text-[--text-muted] uppercase mb-1 block">Date From</label>
        <input
          type="date"
          value={filters.date_from}
          onChange={(e) => setFilters((f) => ({ ...f, date_from: e.target.value }))}
          className="w-full text-sm border border-[--border] rounded-lg px-2 py-1.5"
        />
      </div>
    </div>
  );
}
